import React from "react";
import { useState } from "react";
import { Icon } from '@iconify/react';
import Modal from "../../components/modal";
import Button from "../../components/button"
import AvatarEditor from "react-avatar-editor"
import Headline5 from "../../components/headings/Headline5";
import Styles from "./styles.module.scss";

interface props {
  onClose?: any;
  profileImage?: any;
  submitImage?: any
  companyName?: any;
}
const CropPopUp: React.FC<props> = ({
  onClose,
  profileImage,
  submitImage,
  companyName
}) =>  {
  
  const[image , setImage] = useState<any>()
  const[position, setPosition] =useState<any>({x:0.5,y:0.5})
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const[allowZoomOut , setAllowZoomOut] = useState()
  const[scale , setScale] = useState<any>(1)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const[width , setWidth] =useState<number>(275)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [height , setHeight] = useState<number>(275)
  const[rotate , setRotate] = useState<any>(0)
  const [editor , setEditor] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [borderRadius , setBorderRadius] = useState<any>(0)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [imgName , setImgName] = useState<string>()

  const submitPicture = () => {
    const canvasScaled = editor.getImageScaledToCanvas()
    const croppedImg = canvasScaled.toDataURL()   
    submitImage(croppedImg)
  }
  
  const handlePositionChange = (position : any) => {
    setPosition(position);
  }

  const handleNewImage = async (e: any) => {
    setImgName(e.target.files[0].name)
    await setImage( e.target.files[0] )  
  }

  const handleScale = (e : any) => {
    let scale = parseFloat(e.target.value);
    setScale(scale)   
  }

  const rotateLeft = (e : any) => {
    e.preventDefault();
    setRotate(rotate - 90)
  }

  const rotateRight = (e: any) => {
    e.preventDefault();
    setRotate(rotate + 90);
  }
  
  const setEditorRef = (ed: any) => {
    setEditor(ed)
  }
  
return (
  <Modal title={" "} size="mediumTwo" onClose={onClose}>
    <Headline5><Icon icon="ic:round-arrow-back" className="backicon" /> Crop and rotate</Headline5>
    <div className="App">
      <div className="text-center">
        <AvatarEditor
          ref={setEditorRef}
          scale={parseFloat(scale)}
          width={width}
          height={height}
          position={position}
          onPositionChange={handlePositionChange}
          rotate={parseFloat(rotate)}
          borderRadius={width / (100 /borderRadius)}
          image={image ? image : profileImage}
        />
      </div> 
    </div>
    <div className={Styles.uploadOptions}>
      <label><Icon icon="lucide:upload"/><input type="file" onChange={handleNewImage} />Choose picture</label>
    </div>
    <div className={Styles.cropOptions}>
      <div className={Styles.scaleWrap}>
        <label>Zoom</label>
        <input
          name="scale"
          type="range"
          onChange={handleScale}
          min={allowZoomOut ? "0.1" : "1"}
          max="2"
          step="0.01"
          defaultValue="1"
        />
      </div> 
      <div className="subAction">
        <label>Rotate</label>
        <Button onClick={rotateLeft} variant="secondary">
          <Icon icon="ic:baseline-rotate-90-degrees-cw" hFlip={true}  className="btnIcon" />left
        </Button>
        <Button onClick={rotateRight} variant="secondary">
          <Icon icon="ic:baseline-rotate-90-degrees-cw" className="btnIcon" />Right
        </Button>
      </div>
    </div>
    <div className="popupAction"> 
      <Button onClick={onClose} variant="secondary">Close</Button>
      <Button onClick={submitPicture} variant="primary">Save</Button>
    </div>
    </Modal>
  )
}
export default  CropPopUp

